import React from 'react';
import { DynamicYieldBaseUrls, PixelTracking } from '../cms/dynamicYield.constants';

type Props = {
  event: string;
};

const DynamicYieldEvent = (props: Props) => {
  const { event } = props;
  const authorizationUrl = `${DynamicYieldBaseUrls.PIXEL_BASE_URL}/dpx?sec=${PixelTracking.SEC}&name=${event}`;

  return (
    <div data-test="dy-event-tracking">
      <img
        src={authorizationUrl}
        width="1"
        height="1"
        alt="dy_event"
        style={{ visibility: 'hidden' }}
      />
    </div>
  );
};

export default DynamicYieldEvent;
